import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[700px] md:min-h-[880px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20and%20artistic%20anime-style%20illustration%20of%20cherry%20blossoms%20falling%20in%20a%20mystical%20twilight%20sky%2C%20soft%20pink%20and%20warm%20amber%20gradient%2C%20silhouettes%20of%20floating%20islands%20and%20ancient%20Japanese%20temples%20in%20the%20distance%2C%20lens%20flare%20through%20petals%2C%20dreamlike%20atmosphere%2C%20painterly%20digital%20art%2C%20cinematic%20wide%20composition%2C%20very%20subtle%20warm%20toned%20background%20with%20high%20contrast%20foreground%20elements%2C%20ethereal%20lighting%20from%20above&width=1920&height=1080&seq=hero-bg-anime-01&orientation=landscape"
          alt="樱花动漫网 - 免费高清动漫在线观看平台"
          title="樱花动漫网-电视剧电影动漫在线观看-免费高清动漫大全"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-20 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-0">
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-10 h-[1px] bg-white/60"></span>
                <span className="text-white/80 text-xs font-label uppercase tracking-[0.2em]">
                  樱花动漫网
                </span>
              </div>

              <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-black text-white leading-tight text-balance">
                免费高清
                <br />
                动漫大全
                <br />
                <span className="text-primary-300">在线观看</span>
              </h1>

              <div className="grid grid-cols-2 gap-8 md:gap-16 mt-10 max-w-lg">
                <div>
                  <p className="text-white/80 text-sm leading-relaxed">
                    海量动漫、电视剧、电影资源，
                    每日更新最新番剧，免费高清
                    画质，流畅播放体验。
                  </p>
                </div>
                <div className="mt-3 md:mt-5">
                  <p className="text-white/80 text-sm leading-relaxed">
                    覆盖日本动漫、国产动漫、
                    热门电视剧、院线电影，
                    一站式满足您的观影需求。
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 mt-10">
                <Link
                  to="/category/japanese-anime"
                  className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  立即观看
                </Link>
                <Link
                  to="/category/movies"
                  className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-movie-line text-lg"></i>
                  电影专区
                </Link>
              </div>

              <div className="flex items-center gap-6 mt-12">
                <div className="text-center">
                  <p className="text-white text-2xl md:text-3xl font-bold">5000+</p>
                  <p className="text-white/60 text-xs mt-1">动漫资源</p>
                </div>
                <div className="w-[1px] h-8 bg-white/20"></div>
                <div className="text-center">
                  <p className="text-white text-2xl md:text-3xl font-bold">2000万+</p>
                  <p className="text-white/60 text-xs mt-1">忠实用户</p>
                </div>
                <div className="w-[1px] h-8 bg-white/20"></div>
                <div className="text-center">
                  <p className="text-white text-2xl md:text-3xl font-bold">每日更新</p>
                  <p className="text-white/60 text-xs mt-1">新番速递</p>
                </div>
              </div>
            </div>

            <div className="hidden lg:flex items-center justify-end">
              <div className="relative">
                <div className="w-72 h-96 rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl rotate-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20breathtaking%20anime%20key%20visual%20of%20a%20determined%20young%20warrior%20with%20a%20katana%2C%20cherry%20blossom%20petals%20floating%20around%2C%20dramatic%20cinematic%20composition%2C%20warm%20sunset%20colors%20blending%20with%20dark%20shadows%2C%20high%20contrast%2C%20emotional%20anime%20art%20style%2C%20simple%20dark%20gradient%20background&width=600&height=840&seq=hero-card-01&orientation=portrait"
                    alt="热门推荐动漫"
                    title="樱花动漫网热门推荐"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="absolute -bottom-6 -left-6 w-56 h-72 rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl -rotate-6">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20beautiful%20female%20anime%20character%20with%20long%20flowing%20hair%20in%20a%20fantasy%20setting%2C%20magical%20glowing%20particles%2C%20ethereal%20lighting%2C%20soft%20pastel%20pink%20and%20golden%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20anime%20art%20style%2C%20simple%20dark%20background&width=600&height=840&seq=hero-card-02&orientation=portrait"
                    alt="热门推荐动漫"
                    title="樱花动漫网新番推荐"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-primary-500 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-play-fill text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}